// extracted by mini-css-extract-plugin
module.exports = {"vertical_item":"vertical_item___2D8ew","vertical_title":"vertical_title___1sUDE","vertical_sub":"vertical_sub___f3nvK"};